import "react-perfect-scrollbar/dist/css/styles.css";
import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import BubblesTopIcon from "@material-ui/icons/ArrowLeft";
import Avatar from "@material-ui/core/Avatar";
import PerfectScrollbar from "react-perfect-scrollbar";

import styles from "./styles";
import { withStyles } from "@material-ui/core";

class Bubbles extends Component {
  constructor(props) {
    super(props);
    this.bubblesBeginningRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.bubbles && this.props.bubbles.length > 0) {
      this.scrollToBeginning();
    }
  }

  scrollToBeginning = () => {
    try {
      this.bubblesBeginningRef.current._container.scrollLeft = 0;
    } catch (e) {
      console.log("Could not scroll bubbles: " + e.message);
    }
  };

  handleClick = (item, message) => {
    if (item.type === "hierarchy") {
      this.props.bubbleDrillDown(item.children);
    } else if (item.type === "answer") {
      this.props.bubbleAnswer(item);
    } else {
      //ToDo: submit clicked bubble
      this.props.bubblesOnMessageWasSent(message);
    }
  };

  handleBack = () => {
    this.props.bubblesTopLevel();
  };

  listBubbles() {
    const { classes } = this.props;

    if (this.props.bubbles.length < 1) return "";

    let listOfBubbles = this.props.bubbles.map(
      function(item, i) {
        const message = {
          type: "text",
          source: "bubble",
          author: "me",
          data: {
            text: item.utterance
          }
        };

        const itemType = item.type;

        return (
          <Chip
            key={i}
            avatar={
              <Avatar
                alt={item.name}
                src={item.avatar ? item.avatar : "/images/logos/responsum.png"}
                className={classes.bubbleAvatar + " " + classes[itemType]}
              />
            }
            id={`bubble-btn-${i}`}
            name={item.name}
            // size="small"
            onClick={() => this.handleClick(item, message)}
            clickable={!this.props.botIsTyping}
            label={item.name}
            utterance={item.help}
            className={classes[itemType] + " " + classes.bubble}
          />
        );
      }.bind(this)
    );

    // if (this.props.isBubbleDrillDown)
    return (
      <PerfectScrollbar className={"bubble-container"} ref={this.bubblesBeginningRef}>
        {this.props.isBubbleDrillDown ? (
          <Chip
            key="Back"
            id="bubble-back"
            name="Back"
            // size="small"
            onClick={() => this.handleBack()}
            clickable={!this.props.botIsTyping}
            label={<BubblesTopIcon />}
            className={classes["back"] + " " + classes.bubble}
          />
        ) : (
          ""
        )}
        {listOfBubbles}
      </PerfectScrollbar>
    );
    // else
    //   return (
    //     <PerfectScrollbar className={"bubble-container"} ref={this.bubblesBeginningRef}>
    //       {listOfBubbles}
    //     </PerfectScrollbar>
    //   );
  }

  render() {
    if (this.props.bubbles !== null) {
      return this.listBubbles();
    } else {
      return <div className="height-0">{}</div>;
    }
  }
}

export default withStyles(styles)(Bubbles);
